import React, { useState } from "react";
import { useUser } from "@dreamchimney/user-context";

const CommentIcon = (props) => {
  const { state: userState, dispatch } = useUser();
  const handleClick = () => {
    if (!userState.loggedin) {
      dispatch({ type: "signin_open" });
    }
  };
  return (
    <span className="icon-wrapper">
      <a href="#comments" onClick={handleClick}>
        <span>
          <i className="far fa-comment"></i>
        </span>
      </a>
    </span>
  );
};

CommentIcon.propTypes = {
  // bla: PropTypes.string,
};

CommentIcon.defaultProps = {
  // bla: 'test',
};

export default CommentIcon;
